import { useEffect, useState } from "react";

export function useCustomerProfile() {
  const [isLoaded, setIsLoaded] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (window?.salja?.customerProfile) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsLoaded(true);
    } else {
      const intervalId = setInterval(() => {
        if (window?.salja?.customerProfile) {
          clearInterval(intervalId);
          setIsLoaded(true);
        } else {
          setIsLoaded(false);
        }
      }, 500);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, []);

  return {
    isLoaded,
    customerProfile: window?.salja?.customerProfile,
  };
}
